import UserState from '../user_state';
export default {
  props: ['coursework'],
  template: '#resources_step_template',
  data() {
    return {
      number: 0,
      name: 'Resources',
      task: 'View Resources',
      isInView: false
    };
  },
  computed: {
    isVisible() {
      return this.coursework.resources.length > 0;
    },
    isActive() {
      return this.isVisible;
    },
    isComplete() {
      return this.coursework.has_viewed_resources;
    }
  },
  methods: {
    markCompleted() {
      let self = this;
      if (self.isVisible && !self.isComplete) {
        if (Kadenze.UIUtil.isInFullView(self.$el)) {
          UserState.stepCompleted(self.coursework.id, 'resources').done(function () {
            self.coursework.has_viewed_resources = true;
          });
        } else {
          $(window).off('scroll.resources').on('scroll.resources', function() {
            if(Kadenze.UIUtil.isInFullView(self.$el)) {
              UserState.stepCompleted(self.coursework.id, 'resources').done(function () {
                self.coursework.has_viewed_resources = true;
              });
              $(window).off('scroll.resources');
            }
          });
        }
      }
    }
  },
  created() {
    this.$parent.steps.push(this);
  },
  mounted() {
    this.markCompleted();
  }
};
